import React, { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom';



const ProtectedAdminRoutes = () => {
    return (localStorage.getItem('Rolle') == 10) ? <Outlet /> :  <Navigate to="/" replace={true} />
}

export default ProtectedAdminRoutes;